<template>
  <div>
    <YearReportTable />
  </div>
</template>

<script>
import YearReportTable from "@/views/monitoring/views/reports/components/year/YearReportTable.vue";

export default {
  components: {
    YearReportTable,
  },
};
</script>

<style>
</style>